module.exports = __webpack_public_path__ + "img/121.ff429950.jpg";